@if (overlayService.config$ | async; as config) {
  <pc-overlay
    [config]="config | mapOverlayConfig"
    (closeClick)="triggerCloseAction()"
    [id]="'pc-status-overlay-' + config.type"
    [small]="small"
  >
    <!-- Body -->
    <ng-container body>
      <div class="pc-status-overlay__body">
        <div class="pc-status-overlay__icon-container">
          @if (config.type === 'success') {
            <pc-icon
              class="pc-status-overlay__icon"
              name="successCircle"
              color="var(--success-green)"
              data-analytics="analytics-consequence-modal-headline-success-icon analytics-succcess"
            ></pc-icon>
          }
          @if (config.type === 'error') {
            <pc-icon
              class="pc-status-overlay__icon"
              name="error"
              color="var(--error-red)"
              data-analytics="analytics-consequence-modal-headline-success-icon analytics-error"
            ></pc-icon>
          }
          @if (config.type === 'warning') {
            <pc-icon
              class="pc-status-overlay__icon"
              name="warning"
              color="var(--warning-yellow)"
              data-analytics="analytics-consequence-modal-headline-success-icon analytics-attention"
            ></pc-icon>
          }
          @if (config.type === 'spinner') {
            <mat-spinner [diameter]="58"> </mat-spinner>
          }
        </div>
        <span class="pc-status-overlay__message" [innerHTML]="config.message"></span>
        @if (config.extraInfo) {
          <span>{{ config.extraInfo }}</span>
        }
      </div>
    </ng-container>

    <!-- Buttons -->
    <ng-container buttons>
      @if (config.primaryAction || config.secondaryAction) {
        <div class="pc-status-overlay__footer">
          @if (config.secondaryAction) {
            <pc-button
              [text]="config.secondaryAction.text"
              size="small"
              variant="secondary"
              [verifiable]="config.secondaryAction.verifiable"
              (btnClick)="triggerSecondaryAction($event)"
            ></pc-button>
          }
          @if (config.primaryAction) {
            <pc-button
              [text]="config.primaryAction.text"
              size="small"
              [verifiable]="config.primaryAction.verifiable"
              (btnClick)="triggerPrimaryAction($event)"
            ></pc-button>
          }
        </div>
      }
    </ng-container>
  </pc-overlay>
}
